export default __webpack_public_path__ + "static/vuengine-studio-min-f112fc4dac0347843579e3a988d61aba.png";